import Service from '@ember/service';

// eslint-disable-next-line ember/no-classic-classes
export default Service.extend({
  unknownProperty(key) {
    return window.localStorage[key];
  },

  setUnknownProperty(key, value) {
    if (value == null) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage[key] = value;
    }
    this.notifyPropertyChange(key);
    return value;
  },
});
